"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRetry = void 0;
const Retry_1 = require("./Retry");
/**
 * Wraps a function with retries and returns a function with the same signature so that it can be used as if it were the original function.
 * @param f the function to wrap.
 * @param opts the options for the retry.
 * @param logger the logger.
 * @returns A function with the same signature as @param f but that will retry.
 */
function withRetry(f, opts, logger) {
    return (...args) => {
        return new Retry_1.Retry(opts.strategy, logger, opts.maxAttempts).execute(() => f(...args), opts.shouldRetryOnError, opts.shouldRetryOnResult);
    };
}
exports.withRetry = withRetry;
